<script>
import IconSearch from "@js/components/Icons/IconSearch.vue";
import {useSearchStore} from "@js/store/SearchStore.js";
import IconX from "@js/components/Icons/IconX.vue";
import IconCamera from "@js/components/Icons/IconCamera.vue";
import {onMounted, ref} from "vue";

export default {
    name: "TopBarMobileSearchInput",
    components: {IconCamera, IconX, IconSearch},
    props: {
        camera_colored: {
            default: true,
        }
    },
    setup() {
        const searchStore = useSearchStore()

        return {searchStore}
    }
}
</script>

<template>
    <div class="relative shadow-sm overflow-hidden rounded-lg"
         @click.prevent="searchStore.showDropdown">
        <div
            class="block min-h-[46px] w-full p-3 ps-4 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-0 focus:border-baseColor">
            {{ searchStore.currentPlaceholder }}
        </div>
        <button type="button" aria-label="Поиск"
                v-if="!searchStore.query"
                :class="[camera_colored ? 'text-black bg-baseColor' : 'text-gray-700']"
                class="absolute z-1 top-0 end-0 flex items-center justify-center h-full p-2.5 min-w-[45px] text-sm font-medium rounded-e focus:outline-none focus:ring-0 transition">
            <IconSearch :class="[camera_colored ? 'w-5 h-5' : 'w-6 h-6']" class="text-white"/>
        </button>
        <button v-if="searchStore.query"
                @click.prevent="searchStore.clearQuery"
                type="button"
                class="absolute z-1 inset-y-0 end-[10px] flex items-center px-2 text-gray-400 md:hover:text-red-500"
                aria-label="Очистить поиск">
            <IconX class="w-5 h-5 stroke-gray-400"/>
        </button>
    </div>
</template>

<style scoped lang="scss">
.z-1 {
    z-index: 1;
}
</style>
